
import Http from './Http'

export default {
    async getCustomerStatistics(days) {
        return await Http.get(`/statistics/users?days=${days}`)
    },
    async getDevicesStatistics(days) {
        return await Http.get(`/statistics/devices/active?days=${days}`)
    },
    async getOrdersTotalStatistics(days) {
        return await Http.get(`/statistics/orders?days=${days}`)
    },
    async getOrdersStatisticsByType(days, graphType) {
        return await Http.get(`/statistics/ordersByType?days=${days}&type=${graphType}`)
    },
    async getTicketingTotalStatistics(days) {
        return await Http.get(`/statistics/ticketing?days=${days}`)
    },
    async getCustomerDevicesStatistics(days,graphType) {
        return await Http.get(`/statistics/customerDevices?days=${days}&type=${graphType}`)
    },
    async getSessionsStatistics(days) {
        return await Http.get(`/statistics/sessions/active?days=${days}`)
    },
    async getDashboardCharts(data){
        return await Http.get(`/statistics/dashboard_charts?${data}`)

    },
    async addDashboardCharts(data){
        return await Http.post(`/statistics/dashboard_charts`,data)
    },
    async deleteDashboardChart(data){
        return await Http.delete(`/statistics/dashboard_charts?${data}`)
    },
    async getDeeplinkStatistics(days,graphType,guid) {
        return await Http.get(`/statistics/deeplink?days=${days}&type=${graphType}&guid=${guid}`)
    },
    async getTopMerchandiseProducts(data) {
        return await Http.get(`/statistics/merchandise/top?${data}`)
    },
    async getUsersByGender() {
        return await Http.get(`/statistics/users/gender`)
    },
    async getUsersByAge() {
        return await Http.get(`/statistics/users/age`)
    },
    async getLoginStatistics(data) {
        return await Http.get(`/statistics/login?${data}`)
    },
    async getApplications(data) {
        return await Http.get(`/statistics/applications?${data}`)
    },
    async getMotmParticipation() {
        return await Http.get(`/statistics/games/motm/participation`)
    },
    async getGtsParticipation() {
        return await Http.get(`/statistics/games/gts/participation`)
    },
    async getDeviceTotalCount() {
        return await Http.get(`/statistics/devices/total`)
    },
    async getDeviceLinkedCount() {
        return await Http.get(`/statistics/devices/linked`)
    },
    async getDeviceCountByPlatform() {
        return await Http.get(`/statistics/devices/platform`)
    },
    async getDeviceCountByAppVersion() {
        return await Http.get(`/statistics/devices/byAppVersion`)
    },
    async getDeviceCountByOsByPlatform(platform, select = '') {
        const query = select ? `&select=${encodeURIComponent(select)}` : ''
        return await Http.get(`/statistics/devices/by-os?platform=${platform}${query}`)
    },

}


